
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface MetricCardProps {
  title: string;
  value: string;
  subtext: string;
  valueClassName?: string;
}

const MetricCard: React.FC<MetricCardProps> = ({ 
  title, 
  value, 
  subtext,
  valueClassName = "text-2xl font-bold" 
}) => {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium text-muted-foreground">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className={valueClassName}>{value}</div>
        <div className="text-xs text-muted-foreground mt-1">
          {subtext}
        </div>
      </CardContent>
    </Card>
  );
};

export default MetricCard;
